export default __webpack_public_path__ + "static/media/SaleIconActive.2f9dbda7.svg";